import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable, of } from 'rxjs';
import { debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { GenericService } from '@huge-monorepo/hip/services';
import { Environment } from '@huge-monorepo/hip/services';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { CommonModule } from '@angular/common';
import { log } from 'console';



@Component({
  selector: 'tools-multi-autocomplete',
  templateUrl: './multi-autocomplete.component.html',
  styleUrls: ['./multi-autocomplete.component.scss'],
  imports: [MaterialModule, CommonModule],
  standalone: true,
})
export class MultiAutocompleteComponent implements OnInit, AfterViewInit {
  @ViewChild(MatAutocompleteTrigger, { static: false }) autocomplete: MatAutocompleteTrigger;
  @ViewChild('autoInput', { static: false }) autoInput: ElementRef;

  @Input() name: string = null;
  @Input() primary: string = 'ID';
  @Input() column: string = 'Name';
  @Input() path: string = null;
  @Input() placeholder: string = 'Select an item';
  @Input() disabled: Boolean = false;
  @Input() ObjectListKey: string;
  @Input() label: string;
  @Input() hint: string;
  @Input() enableall: boolean = true;
  @Input() formatter: Function = (elem) => {
    return elem[this.column] && elem[this.column] != '' ? elem[this.column] : '-';
  };
  @Input() sort: boolean = false;
  @Input() sortColumn: string = 'Name';
  @Input() count: number = 50;
  @Input() post: boolean = false;
  @Input() postObj: boolean = false;
  @Input() preloadData: boolean = false;

  @Output() selected: EventEmitter<any> = new EventEmitter<string>();
  @Output() all: EventEmitter<any> = new EventEmitter<boolean>();

  @Input() selection: any[] = [];
  myControl = new UntypedFormControl();
  filteredOptions: Observable<any[]>;
  options: any = [];
  visible = true;
  selectable = true;
  removable = true;
  allSelected: boolean = false;
  preloadedData: any[] = null;

  constructor(public db: GenericService, @Inject(Environment) private environment: any) { }

  ngOnInit() {
    if (this.disabled) {
      this.myControl.disable();
    }
  }

  ngAfterViewInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      switchMap((value) => {


        let tmp = this.preloadData ? this.filterLocalData(value) : this.doFilter(value);


        if (tmp == null) {
          return [];
        } else {
          return tmp;
        }
      }),
    );
  }

  filterLocalData(value: any): Observable<any[]> {
    return this.doFilter("").pipe(
      switchMap((res) => {


        this.preloadedData = res;
        if (value == null || value == "") {
          return of(res);
        }
        const filterValue = value.toLowerCase().trim();
        const filteredData = this.preloadedData.filter(
          (option: any) =>
            JSON.stringify(option).toLowerCase().trim().includes(filterValue)
        );
        return of(filteredData);
      })
    );
  }

  remove(fruit: any): void {
    const index = this.selection.indexOf(fruit);
    if (index >= 0) {
      this.options.unshift(fruit);
      this.selection.splice(index, 1);
    }
    this.notifySelected(this.selection);
  }

  itemSelected(obj: any) {
    const i = this.selection.findIndex((value) => value[this.primary] === obj[this.primary]);
    if (i == -1) {
      this.selection.push(obj);
      let index = this.options.findIndex((val) => val[this.primary] == obj[this.primary]);
      if (index !== -1) {
        this.options.splice(index, 1);
      }
      this.notifySelected(this.selection);
    }
    this.myControl.reset();
    this.myControl.updateValueAndValidity();
    if (this.autoInput) {
      this.autoInput.nativeElement.blur();
    }
  }

  displayFn(ob?: any): any {
    return ob != null ? ob['Display'] : ob;
  }

  doFilter(name: any) {

    if (this.preloadData === false || this.preloadedData === null) {
      if (typeof name == 'string') {
        let hasParams = this.path.indexOf('?');
        let url =
          this.environment.apiLink + this.path + (hasParams !== -1 ? '&' : '?') + 'search=' + name + '&count=' + this.count + (this.sort ? '&orderBy=' + this.sortColumn : '');
        let requester = this.db.GET(url);
        if (this.post) {
          requester = this.db.POSTANDOBSERVE(url, this.postObj);
        }
        return requester.pipe(
          map((res) => {
            let obj = res['body'];
            // console.log(obj);
            if (obj != null) {
              let response = this.ObjectListKey != null ? obj[this.ObjectListKey] : obj;
              let filtered = [];
              if (response != null) {
                response.forEach((element) => {
                  if (this.selection.findIndex((val) => val[this.primary] == element[this.primary]) === -1) {
                    element['Display'] = this.formatter(element);
                    filtered.push(element);
                  }
                });
              }
              this.options = filtered;
              return response;
            }
          }),
        );
      } else {
        return of(this.options);
      }
    } else {
      return of(this.preloadedData);
    }
  }

  notifySelected(obj: any[]) {
    this.selected.emit(obj);
  }

  reset(eve) {
    eve.stopPropagation();
    eve.preventDefault();
    this.selection.forEach((element) => {
      this.options.unshift(element);
    });
    this.selection = [];
    this.notifySelected(this.selection);
    this.allSelected = false;
    if (this.autoInput) {
      this.autoInput.nativeElement.blur();
    }
    this.filteredOptions = of(this.options);
  }

  markAsTouched() {
    this.myControl.setErrors({ invalid: true });
    this.myControl.markAsTouched();
  }

  unMarkAsTouched() {
    this.myControl.setErrors(null);
  }

  disable() {
    this.myControl.disable();
  }

  enable() {
    this.myControl.enable();
  }

  toggleAll(eve) {
    this.closeAuto();
    this.allSelected = eve;
    if (this.allSelected) {
      this.myControl.disable();
    } else {
      this.myControl.enable();
      this.selection.forEach(elem => {
        this.options.unshift(elem);
      });
      this.selection = [];
    }
    if (this.autoInput) {
      this.autoInput.nativeElement.blur();
    }
    this.all.emit(this.allSelected);
    this.notifySelected(this.selection);
  }

  closeAuto() {
    this.autocomplete.closePanel();
  }

  openAuto() {
    this.autocomplete.openPanel();
  }
}
